import { render, staticRenderFns } from "./cause-form.vue?vue&type=template&id=2f401956&"
import script from "./cause-form.vue?vue&type=script&lang=js&"
export * from "./cause-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports